//import Vue from 'vue'
import 'chartist/dist/index.css'
import * as chartist from 'chartist';

export default chartist;
